// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--Dskc7"};